import React from 'react';
import ReactTooltip from 'react-tooltip';
import { oneOf, string } from 'prop-types';
import styled from 'styled-components/macro';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { colors } from '../../css/constants';

// todo check if can be removed after upgrading to v5
// !important is necessary to override library style which has 0.9 opacity,
// which looks bad in light mode
const Tooltip = styled(ReactTooltip)`
  width: 20em;

  &.show {
    opacity: 1 !important;
  }
`;

const TooltipContainer = styled.span`
  margin-left: 1rem;
`;

/* A right-aligned help icon that shows the message on hover as a tooltip */
const FormTooltip = ({ message, className, place, type }) => {
  const typeProps = type === 'light' && {
    textColor: colors.sohoGray,
    backgroundColor: colors.lightGrey
  };
  return (
    <TooltipContainer className={className} data-tip={message}>
      <FontAwesomeIcon icon={regular('circle-question')} />
      <Tooltip place={place} effect="solid" type={type} {...typeProps} />
    </TooltipContainer>
  );
};

FormTooltip.propTypes = {
  message: string.isRequired,
  place: string,
  className: string,
  type: oneOf(['dark', 'light'])
};
FormTooltip.defaultProps = {
  className: '',
  place: 'right',
  type: 'dark'
};

export default FormTooltip;
